import React from "react";
import ocel from "../../images/ocel.jpg";
import zintec from "../../images/zintec.jpg";
import nehOcel from "../../images/nehrdzavejucaOcel.jpg";
import hlinik from "../../images/hlinik.jpg";
import med from "../../images/med.jpg";

const NotFound404 = () => {
    return (
        <>
            <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6" id="intro2">
                <div className="my-4 py-4">
                    <h1 className="my-2 text-center text-3xl text-brand uppercase font-bold">404</h1>

                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4 border-brand'></div>
                    </div>
                    <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-black">Tu sme žiaľ nič
                        nenašli.</h2>

                    <p className='text-xl mb-8 mt-10 text-center'>
                        Pokračujte na <a
                        className='underline  text-brand hover:text-black'
                        title="M&rivet s.r.o"
                        href="https://www.mrivet.sk">úvodnú
                        stránku</a>.
                    </p>

                </div>

            </div>
        </>
    );
};

export default NotFound404;
